module.exports = __webpack_public_path__ + "static/pulsio_box_with_circle_mobile-f761987c138ebcb5e870fe31c7e9c69e.png";